import { getCurrencySymbol } from '../../../../../../utils/getCurrencySymbol'
import { getPromoResult } from '../../../../../../store/actions/promocode'
import { useLocation, useParams } from 'react-router-dom'
import React, { useMemo, useState } from 'react'
import styles from './PromocodeV2.module.scss'
import queryString from 'query-string'
import { useEffect } from 'react'

export const PromocodeV2 = ({
  promoRes,
  setPromoRes,
  checkedProducts,
  promocode,
  setPromocode,
  setPromocode_id,
  setPromoEr,
  payment_method_id,
  currency
}) => {
  const [promoError, setPromoError] = useState(false)
  const [promoSuc, setPromoSuc] = useState(false)
  const [error, setError] = useState('')

  const { id } = useParams()
  const location = useLocation()
  const query = queryString.parse(location.search)

  const getParamsPromo = Array.isArray(query.promocode)
    ? query.promocode?.slice(0, 1).join('').toUpperCase().trim()
    : query.promocode?.toUpperCase().trim()

  useEffect(() => {
    if (getParamsPromo !== undefined) {
      setPromocode(getParamsPromo)
    }
  }, [])

  useEffect(() => {
    setPromocode_id(promoRes?.id ?? 0)
    if (promoRes?.success) {
      setPromoError(false)
      setPromoSuc(true)
    } else if (promoRes === 'Promocode not found') {
      setError('Промокод не найден')
      setPromoError(true)
      setPromoSuc(false)
    } else if (promoRes === 'Promocode failed') {
      setError('Промокод не действует для данной формы')
      setPromoError(true)
      setPromoSuc(false)
    } else if (promoRes === 'Promocode count ended') {
      setError('Действие промокода закончилось')
      setPromoError(true)
      setPromoSuc(false)
    }
  }, [promoRes])

  async function handlePromo() {
    const res = await getPromoResult(
      promocode,
      id,
      checkedProducts,
      payment_method_id
    )
    setPromoRes(res?.data.result)
  }

  function cancelPromo() {
    setPromocode('')
    setPromoError(false)
    setPromoSuc(false)
    setPromoRes(null)
    setPromoEr('')
  }

  const salePrice = useMemo(() => {
    return promoRes?.products?.reduce((sum, el) => sum + el.price_difference, 0)
  }, [promoRes])

  const handleChange = (e) => {
    const promo = e.target.value.toUpperCase().trim()
    setPromocode(promo)
    if (!promo) {
      setPromoError(false)
      setPromoRes(null)
    }
  }

  return (
    <div data-testid="promocode-main" className={styles.main}>
      {promoSuc && (
        <div
          data-testid="promocode-saleTitleBox"
          className={styles.saleTitleBox}
        >
          <div data-testid="promocode-saleTitle" className={styles.saleTitle}>
            Скидка по промокоду
          </div>
          <div data-testid="promocode-saleTitle" className={styles.saleSum}>
            -{salePrice?.toLocaleString('ru-RU')}
            {getCurrencySymbol(currency)}
          </div>
        </div>
      )}
      <div data-testid="promocode-inputBox" className={styles.inputBox}>
        <input
          data-testid="promocode-input"
          className={styles.input}
          type="text"
          placeholder="Промокод"
          value={promocode}
          disabled={promoSuc}
          onChange={(e) => handleChange(e)}
        />
        {promocode &&
          (promoSuc ? (
            <div
              data-testid="cancel-promo-button"
              type="button"
              className={styles.cancelPromoBtn}
              onClick={() => cancelPromo()}
            >
              Отменить
            </div>
          ) : (
            <div
              data-testid="activate-promo-button"
              type="button"
              className={styles.promoBtn}
              onClick={() => handlePromo()}
            >
              Применить
            </div>
          ))}
      </div>

      {promoError && (
        <div data-testid="promo-error" className={styles.promoError}>
          <span data-testid="error-message">{error}</span>
        </div>
      )}
    </div>
  )
}
